<template>
    <Layout>
        <!-- Page heading -->
        <div class="relative bg-indigo-800">
            <div class="absolute inset-0">
                <img
                    class="h-full w-full object-cover"
                    src="https://images.unsplash.com/photo-1525130413817-d45c1d127c42?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1920&q=60&&sat=-100"
                    alt=""
                />

                <div class="absolute inset-0 bg-gray-800 mix-blend-multiply" aria-hidden="true" />
            </div>

            <div class="relative mx-auto max-w-7xl px-4 py-24 sm:py-32 sm:px-6 lg:px-8">
                <h1 class="text-3xl font-extrabold tracking-tight text-white sm:text-4xl">
                    {{ $t('All companies') }}
                </h1>
            </div>
        </div>

        <!-- Search form -->
        <div class="relative mx-auto -mt-10 max-w-4xl">
            <form class="flex flex-col space-y-4 md:h-20 md:flex-row md:space-y-0 md:space-x-4 lg:space-x-6" @submit.prevent="search()">
                <input
                    type="text"
                    class="w-full rounded-xl bg-white p-4 shadow"
                    v-model="query"
                    :placeholder="$t('Search by company name')"
                />

                <button class="h-14 rounded-xl bg-gray-800 px-10 text-white hover:bg-gray-700 md:h-20">{{ $t('Search') }}</button>
            </form>
        </div>

        <!-- Offer grid -->
        <ErrorMessage v-if="error">
            {{ $t('An error occured while loading the companies. Please try again.') }}
        </ErrorMessage>

        <div v-else class="mx-auto max-w-7xl space-y-8 px-4 py-10 md:px-8">
            <p v-if="hasSearchQuery && query.length" class="space-x-4">
                <span>
                    {{ $t('Search results for') }}
                    <strong>{{ query }}</strong>
                </span>
                <span>&#8212;</span>
                <InertiaLink href="/repertoire-des-entreprises" class="text-blue-600 hover:underline">
                    {{ $t('Show all companies') }}
                </InertiaLink>
            </p>

            <div class="grid gap-8 md:grid-cols-2 lg:grid-cols-3">
                <CompanyCard v-for="company in companies.data" :key="company.name" :company="company" />
            </div>

            <Pagination :links="companies.links" />
        </div>
    </Layout>
</template>

<script>
    import ErrorMessage from '@/Partials/ErrorMessage';
    import Pagination from '@/Partials/Pagination';
    import CompanyCard from '@/Partials/CompanyCard';

    export default {
        components: {
            ErrorMessage,
            Pagination,
            CompanyCard,
        },

        props: {
            error: Boolean,
            companies: Object,
        },

        data() {
            return {
                query: '',
                hasSearchQuery: false,
            };
        },

        mounted() {
            let url = this.$page.props.url;
            let params = new URLSearchParams(url.split('?')[1]);

            if (params.get('recherche')) {
                this.query = params.get('recherche');
                this.hasSearchQuery = true;
            }
        },

        methods: {
            search() {
                let data = {};

                if (this.query.length) {
                    data.recherche = this.query;
                }

                this.$inertia.visit('/repertoire-des-entreprises', {
                    data: data,
                });
            },
        },
    };
</script>
